import axios from 'axios';
import { message } from 'm-ui';

export function initAxios() {
  axios.interceptors.request.use(
    (config) => {
      return config;
    },
    async (err) => {
      return Promise.reject(err);
    },
  );

  axios.interceptors.response.use(
    async (res) => {
      const { data } = res;
      if (res.config.method === 'get') {
        return data;
      }
      if (!data) {
        const msg = '接口异常';
        throw msg;
      }
      if (+data.result === 1) {
        return res;
      }
      const ignoreCode = [109, 209];
      if (!ignoreCode.includes(+data.result)) {
        data.msg ? message.error(data.msg) : message.error('网络异常');
      }
      throw res?.data || {};
      // return Promise.reject(res?.data || {});
    },
    async (err) => {
      message.error('网络异常');
      return Promise.reject(err || {});
    },
  );
}

initAxios();

export default axios;
